import React from "react";
import { Styles } from "./styles";
import { Rating } from "@mui/material";

const SubscriptionCard = ({ data }) => {
  return (
    <Styles>
        <div className="title-container">

        </div>
        <div className="title-container">
          <div className="title">Name: {data?.user?.name}</div>
          <div className="title">Email: {data?.user?.email}</div>
        </div>
        <div className="title-container">
            <div className="description">Start Date: {new Date(data?.start_date).toLocaleDateString()}</div>
            <div className="description">End Date: {new Date(data?.end_date).toLocaleDateString()}</div>
        </div>

    </Styles>
  );
};

export default SubscriptionCard;
